/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import AppNavStep from '../../../components/appNav/AppNavStep';
import { TextareaAutosize } from '../../../components/TextArea';
import DeleteModal from '../../../components/modal/DeleteModal';

import { Card, Icons } from '../../../../bphComponents/bundle';
import ContentWrapper from '../../../components/ContentWrapper';
import COLORS from '../../../styles/Colors';
import FlexRow from '../../../components/FlexRow';
import ContentFrame from '../../../applicationFrame/ContentFrame';
import AppUtils from '../../../../utilities/AppUtils';

interface State {
  isEditing: boolean;
  showModal: boolean;
}

interface Props {
  value: string;
  placeholderPhrase: any;
  hasInitialFocus: boolean;
  onSubmit(): void;
  onChange(value): void;
  onCancel(): void;
  onDelete(): void;
  loadInitialData?(): void;
  additionalCardContent: any;
  isValid: boolean;
  isCreating: boolean;
  footerLeftContent?: any;
  isSubmitting: boolean;
}

class TextAreaCardView extends React.Component<Props, State> {

  state: State = {
    isEditing: this.props.hasInitialFocus,
    showModal: false,
  };

  UNSAFE_componentWillMount() {
    if (this.props.loadInitialData) {
      this.props.loadInitialData();
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { value, isCreating, onSubmit } = this.props;

    if (!value && isCreating) {
      this.props.onCancel();
    } else if (!value) {
      this.setState({ showModal: true });
    } else {
      onSubmit();
    }
  }

  onChange = (e) => {
    const value = e.target.value;
    this.props.onChange(value);
  }

  onFocus = () => {
    this.setState({
      isEditing: true,
    });
  }

  cancelChanges = (e) => {
    e.preventDefault();
    this.props.onCancel();
  }

  render() {
    const { isEditing, showModal } = this.state;
    const { value, placeholderPhrase, onDelete, additionalCardContent, hasInitialFocus, footerLeftContent, isSubmitting } = this.props;

    const showDone = !isEditing;
    const showSubmit = isEditing;
    const showCancel = showSubmit;
    const editStyles = isEditing ? { borderRadius: 4, borderColor: COLORS.gsMiddleDT } : { borderColor: 'transparent', borderBottomColor: COLORS.gsLight };

    return (
      <div style={{ height: '100%' }}>
        <div className="util-application-content-padding">
          <AppNavStep
            cancel={showCancel ? this.cancelChanges : null}
            done={showDone ? this.onSubmit : null}
            submit={showSubmit ? this.onSubmit : null}
            submitDisabled={isSubmitting}
            color="gsDark"
          />
        </div>

        <ContentFrame className="bkgd-color-light-neutral">

          <ContentWrapper>
            <div>

            <Card.CardShape className="font-title-3">
              <Card.CardContent>
                <TextareaAutosize
                  minRows={AppUtils.isWideView() ? 11 : 8}
                  placeholder={placeholderPhrase}
                  value={value}
                  onChange={this.onChange}
                  autoFocus={hasInitialFocus}
                  onFocus={this.onFocus}
                  className="font-title-3 font-color-textarea-dark"
                  style={{ borderWidth: 0.5, borderStyle: 'solid', resize: 'none', padding: 8, overflowY: 'hidden', ...editStyles }}
                />

                {additionalCardContent && (
                  <div style={{ paddingTop: 20 }}>
                    {additionalCardContent}
                  </div>
                )}
              </Card.CardContent>
            </Card.CardShape>

            <Card.ExternalContent>
              <FlexRow>
                <div>
                  {footerLeftContent}
                </div>
                <div className="is-clickable" onClick={() => { this.setState({ showModal: true }); }}>
                  <Icons.IconTrash.Medium color={COLORS.gsMiddle} />
                </div>
              </FlexRow>

              <DeleteModal
                isVisible={showModal}
                onConfirmAction={() => {
                  this.setState({
                    showModal: false,
                  });
                  onDelete();
                }}
                onCancelAction={() => {
                  this.setState({
                    showModal: false,
                  });
                }}
              />

            </Card.ExternalContent>
            </div>
          </ContentWrapper>
        </ContentFrame>
      </div>
    );
  }
}

export default TextAreaCardView;
